// extracted by mini-css-extract-plugin
export var container = "ShuffleComparison-module--container--c88b9";